import { render, staticRenderFns } from "./TournamentEmbedRegister.vue?vue&type=template&id=c104bce2&scoped=true"
import script from "./TournamentEmbedRegister.vue?vue&type=script&lang=js"
export * from "./TournamentEmbedRegister.vue?vue&type=script&lang=js"
import style0 from "./TournamentEmbedRegister.vue?vue&type=style&index=0&id=c104bce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c104bce2",
  null
  
)

export default component.exports